import { styled } from '@mui/system';
import { FormControlLabel, Box, Typography } from '@mui/material';

export const IntroTypography = styled(Typography)(({ theme }) => ({
  color: 'white',
  fontSize: '1.2rem',
  lineHeight: '1.8',
  margin: '40px auto',
  maxWidth: '800px',
  textAlign: 'center',
  padding: '0 20px',
  [theme.breakpoints.down('md')]: {
    fontSize: '1rem',
    margin: '30px auto',
    padding: '0 15px',
  },
}))

export const SectionContainer = styled('section')(({ theme }) => ({
  position: 'relative',
  width: '100%',
  height: '100vh',
  overflow: 'hidden',
  backgroundColor: theme.palette.secondary.main,
  backgroundImage: `radial-gradient(circle, ${theme.palette.secondary.light} 1px, transparent 1px)`,
  backgroundSize: '20px 20px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  [theme.breakpoints.down('md')]: {
    height: 'auto',
    minHeight: '70vh',
    padding: '40px 0',
  },
}));

export const StyledBackgroundDiv = styled('div')(({theme}) => ({
  backgroundColor: theme.palette.secondary.main,
  backgroundImage: `radial-gradient(circle, ${theme.palette.secondary.light} 1px, transparent 1px)`,
  backgroundSize: '20px 20px',
}))



export const StyledRadioGroupContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(3),
  textAlign: 'center',
  boxShadow: `0px 0px 10px 2px rgba(255, 255, 255, 0.5)`,
  margin: `${theme.spacing(4)} auto`,
  width: '100%',
  maxWidth: '500px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(2),
    maxWidth: '90%',
  },
}));

export const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  "& .MuiTypography-root": {
      color: theme.palette.text.primary,
      fontWeight: 700,
      fontSize: '1.2rem',
  },
  "& .Mui-checked": {
      color: theme.palette.info.main,
  },
}));